/**
 * AI Events
 */
export const aiAuditEvents = {
    aiMessageMenuOpened: "AI Message Menu Opened",
    /**
     * Payload: { template: "ImproveWriting" | ..., tone?: "formal" | ...  }
     */
    aiMessageRequested: "AI Message Requested",
    /**
     * Payload: { action: "append" | "replace" | "discard" }
     */
    aiMessageApplied: "AI Message Applied",
    aiMessageRetried: "AI Message Retried",
} as const;
